import { studyPath } from "../data.js";
import { localizeField } from "../i18n.js";
import PostRow from "./PostRow.jsx";

export default function PathPage({ t, copy, language }) {
  return (
    <div>
      <h2 style={{ fontSize: 20, fontWeight: 400, marginBottom: 18 }}>{copy.studyPath}</h2>
      <div>
        {studyPath.map((post, i) => (
          <PostRow
            key={post.date}
            label={post.date}
            title={localizeField(post, "title", language)}
            isFirst={i === 0}
            t={t}
            subtitle={localizeField(post, "school", language)}
            copy={copy}
          />
        ))}
      </div>
    </div>
  );
}
